import React from 'react';
import { Typography, Card } from 'antd';
import GoogleAnalyticsDashboard from '../../components/GoogleAnalyticsDashboard';
import SEOHead from '../../components/SEOHead';

const { Title, Paragraph } = Typography;

const SEOAnalytics = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', padding: '20px 0' }}>
      <SEOHead
        title="SEO Analytics Dashboard - Lumi Bears"
        description="Internal SEO analytics dashboard for monitoring organic search performance and optimization opportunities."
        noindex={true}
      />
      
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        {/* Page Header */}
        <Card style={{ marginBottom: '20px', textAlign: 'center' }}>
          <Title level={2} style={{ color: '#2c3e50' }}>
            SEO Analytics Dashboard
          </Title>
          <Paragraph style={{ fontSize: '16px', color: '#7f8c8d', maxWidth: '600px', margin: '0 auto' }}>
            Connect your Google Analytics account to monitor organic search performance, 
            identify optimization opportunities, and track the success of your SEO efforts.
          </Paragraph>
        </Card>

        {/* Google Analytics Dashboard */}
        <GoogleAnalyticsDashboard />

        {/* SEO Implementation Status */}
        <Card title="Current SEO Implementation Status" style={{ marginTop: '20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
            <div style={{ padding: '12px', background: '#f0f9ff', borderRadius: '8px' }}>
              <Title level={5} style={{ color: '#1890ff', margin: '0 0 8px 0' }}>✅ Meta Tags Optimized</Title>
              <Paragraph style={{ margin: 0, fontSize: '14px' }}>
                Title tags, descriptions, and Open Graph implemented across all pages
              </Paragraph>
            </div>
            
            <div style={{ padding: '12px', background: '#f6ffed', borderRadius: '8px' }}>
              <Title level={5} style={{ color: '#52c41a', margin: '0 0 8px 0' }}>✅ Schema Markup Active</Title>
              <Paragraph style={{ margin: 0, fontSize: '14px' }}>
                Organization, Product, Article, FAQ, and Breadcrumb schemas implemented
              </Paragraph>
            </div>
            
            <div style={{ padding: '12px', background: '#fff7e6', borderRadius: '8px' }}>
              <Title level={5} style={{ color: '#fa8c16', margin: '0 0 8px 0' }}>✅ Internal Linking System</Title>
              <Paragraph style={{ margin: 0, fontSize: '14px' }}>
                Systematic cross-linking between blog posts and product pages
              </Paragraph>
            </div>
            
            <div style={{ padding: '12px', background: '#f9f0ff', borderRadius: '8px' }}>
              <Title level={5} style={{ color: '#722ed1', margin: '0 0 8px 0' }}>✅ Performance Optimized</Title>
              <Paragraph style={{ margin: 0, fontSize: '14px' }}>
                Core Web Vitals monitoring, lazy loading, and resource hints active
              </Paragraph>
            </div>
          </div>
        </Card>

        {/* Quick SEO Checklist */}
        <Card title="SEO Health Checklist" style={{ marginTop: '20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '16px' }}>
            <div>
              <Title level={5}>Technical SEO</Title>
              <ul style={{ paddingLeft: '20px' }}>
                <li>✅ Meta tags optimized</li>
                <li>✅ Schema markup implemented</li>
                <li>✅ Breadcrumb navigation</li>
                <li>✅ Core Web Vitals monitoring</li>
                <li>✅ Image optimization (lazy loading)</li>
              </ul>
            </div>
            
            <div>
              <Title level={5}>Content SEO</Title>
              <ul style={{ paddingLeft: '20px' }}>
                <li>✅ FAQ sections with schema</li>
                <li>✅ Internal linking strategy</li>
                <li>✅ Blog post optimization</li>
                <li>✅ Product page enhancement</li>
                <li>🔄 Regular content updates needed</li>
              </ul>
            </div>
            
            <div>
              <Title level={5}>Analytics & Monitoring</Title>
              <ul style={{ paddingLeft: '20px' }}>
                <li>✅ Google Analytics integration</li>
                <li>✅ Performance tracking setup</li>
                <li>🔄 Regular SEO audits recommended</li>
                <li>🔄 Competitor analysis needed</li>
                <li>🔄 Keyword ranking monitoring</li>
              </ul>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default SEOAnalytics;